// John Eldhose 20180523
import { RestfulPost } from './Restful';

export async function myProducts(pageSize, page, sorted) {
  let data = {
    pageSize: pageSize,
    page: page,
    sorted: sorted
    //filtered
  };

  const Prod = await RestfulPost('myproducts', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return Prod;
}



// WEBPACK FOOTER //
// ./src/Api/myProducts.js